const context = 'appState'

export const SET_PAGE_SIZE = `${context}/SET_PAGE_SIZE`
export const SET_SEARCH_QUERY = `${context}/SET_SEARCH_QUERY`
export const SET_CONFIGURED_POS_VISIBLE = `${context}/SET_CONFIGURED_POS_VISIBLE`
export const SET_CONFIGURED_BOARDS_VISIBLE = `${context}/SET_CONFIGURED_BOARDS_VISIBLE`
export const SET_CONFIGURED_PRINTERS_VISIBLE = `${context}/SET_CONFIGURED_PRINTERS_VISIBLE`
export const SET_CURRENT_PAGINATION_PAGE = `${context}/SET_CURRENT_PAGINATION_PAGE`
export const UPDATE_OFFSET = `${context}/UPDATE_OFFSET`
